import store from "@/store";

export function formatMoney(amount) {
  const symbol = store.getters.currencySymbol || "GH₵ ";
  const n = Number(amount || 0);
  return `${symbol}${n.toFixed(2)}`;
}

export const CURRENCY_OPTIONS = [
  { value: "GHS", text: "GHS — Ghana Cedi (GH₵)" },
  { value: "USD", text: "USD — US Dollar ($)" },
  { value: "EUR", text: "EUR — Euro (€)" },
  { value: "GBP", text: "GBP — British Pound (£)" },
  { value: "NGN", text: "NGN — Nigerian Naira (₦)" },
];
